import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import "../JobListingCard/JobListingCard2.css";
import "./BookingCard.css";
import "../../Components-Pages/Bookings2/JobList.css";
import Moment from "react-moment";
import { parseTime, teacherResponse, getClass, teacherLevel, teacherStatus, getQualificationTypeForBooking, getTeacherEltRateByTeacherLevel } from "../../Helper";
import { Link } from "react-router-dom";
import CancelButton from "../Buttons/CancelButton";
import ConfirmButton from "../Buttons/ConfirmButton";
import CancelBookingPopup from "./CancelBookingPopup";
import RequestDayOffPopup from "./RequestDayOffPopup";
import ForumIcon from "@material-ui/icons/Forum";
import ReactTooltip from "react-tooltip";
import { dateToISO } from "../../Helper";
import DescriptionIcon from '@mui/icons-material/Description';
import carParkingImg from '../../assets/img/car_parking.svg';
import moment from "moment";

const _ = require('lodash');

function BookingCard(props) {
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showRequestDayOffPopup, setShowRequestDayOffPopup] = useState(false);
  let {
    job,
    inst,
    campus,
    minWidth,
    submitResponse,
    user,
    classData,
    isAdmin,
    onCancelJob,
    onAcceptJob,
    onRejectJob,
    requestDayOff,
    handleRequestDayOff,
    teacher,
    qualifications,
  } = props;
  
  // incase the 
  if(!campus || !campus._id && job?.campus) {
    campus = job.campus
  }

  // const today = new Date();
  // let dd = today.getDate();
  // let mm = today.getMonth() + 1;
  // const yyyy = today.getFullYear();

  // if (dd < 10) { dd = '0' + dd; }
  // if (mm < 10) { mm = '0' + mm; }
  // const d1 = yyyy + '-' + mm + '-' + dd;
  const d1 = dateToISO(new Date());

  const classList = getClass();
  let level = classList.find((cl) => cl.key === job.level);
  level = level ? level.whole_name : job.level;

  const getTotalHours = (hoursPerDay) => {
    if (!job.dates.length) return hoursPerDay;
    let count = 0;
    let idx = 0;
    for (let i = 0; i < job.dates.length; i++) {
      if (job.dates[i].date === getValidStartDate(job)) {
        idx = i;
        break;
      }
    }
    for (let i = idx; i < job.dates.length; i++) {
      count++;
      if (job.dates[i].date === job.end_booking_date) break;
    }
    return count * hoursPerDay;
  };

  // console.log('Job is: ', job);

  const startDate = new Date(job.booking_date)
  const endDate = new Date(job.end_booking_date);
  endDate.setDate(endDate.getDate() + 1);
  const daysOfWeekInRange = [];
  let i = 0;
  while (i < 7 && startDate < endDate) {
    daysOfWeekInRange.push(startDate.toLocaleString('en-us', {  weekday: 'long' }));
    startDate.setDate(startDate.getDate() + 1);
    i++;
  }
  let days = job.days_of_delivery?.replace(/^,/, "").split(",")
    .filter(value => daysOfWeekInRange.includes(value)).map(day => day.substr(0,3));
  for (let i = 0; i < days?.length; i++) {
    if (days[i] === 'Tue') {
      days[i] = 'Tues';
    } else if (days[i] === 'Wed') {
      days[i] = 'Weds';
    } else if (days[i] === 'Thu') {
      days[i] = 'Thurs'
    }
  }

  const getValidStartDate = (job) => {
    return job.dates?.find(item => item.date >= job.booking_date)?.date
  }

  const showRateECEC = (job) => {
    const defaultRate = <>
      <p>Certificate III $35.42</p>
      <p>Diploma $41.73</p>
      <p>Bachelor Degree $54.38</p>
      <p>Graduate Diploma $54.38</p>
    </>

    if (job.teacher_response === teacherResponse.accepted || job.teacher_status === teacherStatus.assigned) {
      const level = isAdmin ? teacher?.level : user?.level

      if (level === teacherLevel.CERT) {
        return <>Certificate III $35.42</>
      } else if (level === teacherLevel.DIPLOMA) {
        return <>Diploma $41.73</>
      } else if (level === teacherLevel.BACHELOR) {
        return <>Bachelor Degree $54.38</>
      } else if (level === teacherLevel.GRADUATE_DIPLOMA) {
        return <>Graduate Diploma $54.38</>
      }
    }

    return defaultRate
  }

  const showRate = (job, inst_id) => {
    if(inst_id == '6674b406b9f34b24efc2889e') {
      // CampusQ college
      return (
        <>
        VET $33
        </>
      )
    }
    if (!job.multiple_date) {
      return <>VET ${job?.hourly_rate_teacher || 0}</>
    } else {
      const customerRates = job.dates.map(date => "$" + date.hourly_rate_teacher)
      return <>VET {[...new Set(customerRates)].join(" & ")}</>
    }
  }

  const showDefaultRate = (job, inst_id) => {
    const NEW_RATE_APPLY_DATE = moment('2025-07-01', 'YYYY-MM-DD')
    const bookingDate = moment(job.end_booking_date, 'YYYY-MM-DD');
    const NEW_RATE_APPLY_DATE_2025 = moment('2026-07-01', 'YYYY-MM-DD');
    const newRateFor2025 = moment('2026-01-01', 'YYYY-MM-DD');

    if(inst_id == '6674b406b9f34b24efc2889e') {
      // CampusQ college
      return (
        <>
          Junior/Online $33
          <br />
          Senior $33
        </>
      )
    }
    if(bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE_2025)) {
      if(inst_id === '64dc1e52853fb706cdeec43d') {
        // Ames Australia college
        return (
          <>
            Hourly rate $67.52<br />
          </>
        )
      }
      if (job.teacher_response === teacherResponse.accepted || job.teacher_status === teacherStatus.assigned) {
        const level = isAdmin ? teacher?.level : user?.level
        if (!job.multiple_date) {
          return getTeacherEltRateByTeacherLevel(level, true)
        }

        const rates = job.dates.map(date => getTeacherEltRateByTeacherLevel(date?.teacher_rate, true))
        return <>
          {
            [...new Set(rates)]?.map(rate =>
              <>
                {rate}
                <br/>
              </>)
          }
        </>
      }

      return (
        <>
          Junior/Online $66.25
          <br/>
          Senior $72.34
          <br/>
          Expert $78.25
          <br/>
          Master $82.30
        </>
      );
    } else if (bookingDate.isSameOrAfter(newRateFor2025)) {
      if(inst_id === '64dc1e52853fb706cdeec43d') {
        // Ames Australia college
        return (
          <>
            Hourly rate $67.52<br />
          </>
        )
      }
      if (job.teacher_response === teacherResponse.accepted || job.teacher_status === teacherStatus.assigned) {
        const level = isAdmin ? teacher?.level : user?.level
        if (!job.multiple_date) {
          return getTeacherEltRateByTeacherLevel(level)
        }

        const rates = job.dates.map(date => getTeacherEltRateByTeacherLevel(date?.teacher_rate))
        return <>
          {
            [...new Set(rates)]?.map(rate =>
              <>
                {rate}
                <br/>
              </>)
          }
        </>
      }

      return (
        <>
          Junior/Online $69.58
          <br/>
          Senior $75.97
          <br/>
          Expert $82.17
          <br/>
          Master $86.43
        </>
      );
    } else if (bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE)) {
      return (
        <>
          Junior/Online $58.8
          <br />
          Senior $62
        </>
      )
    }

    return (
      <>
        Junior/Online $56.65
        <br />
        Senior $60.75
      </>
    )
  }

  const showRateUni = (job) => {
    const NEW_RATE_APPLY_DATE = moment('2024-07-01', 'YYYY-MM-DD');
    const bookingDate = moment(job.end_booking_date, 'YYYY-MM-DD');
    const newRateFor2025 = moment('2025-01-01', 'YYYY-MM-DD');
    if(bookingDate.isSameOrAfter(newRateFor2025)) {
      return (
        <>
          University English Centre $105
        </>
      )
    }
    else if (bookingDate.isSameOrAfter(NEW_RATE_APPLY_DATE)) {
      return (
        <>
          University English Centre $105.75
        </>
      )
    }
    return (
        <>
          University English Centre $100
        </>
    )
  }

  return (
    <>
      <div
        className={"job-card-outer" + (minWidth ? " job-card-small-new" : "")}
      >
        <div
          className={
            "job-card-container" +
            ((job.end_booking_date || job.booking_date) < d1
              ? " past-background-color"
              : "")
          }
        >
          <div className="w-100 d-flex justify-content-between">
            <div className="d-flex align-items-center mt-2 mb-3">
              <div className="job-card-logo-container">
                <img className="job-card-logo" src={inst.logo || ""} alt="" />
              </div>
              <h3 className="job-card-inst-name">
                {inst._id ? (
                  <>
                    {inst.institution_name}
                    <Link
                      to={"/NavigateToCollegeSharedProfile?id=" + inst._id}
                      target="blank"
                      className="ml-1"
                    >
                      <span className="job-card-tag">
                        <Icon name="share" size="small" />
                        View Profile
                      </span>
                    </Link>
                  </>
                ) : (
                  ""
                )}
              </h3>
            </div>
          </div>
          <div className="job-card-container-inner p-3 d-flex flex-column justify-content-between">
            <div className="w-100 overflow-hidden">
              <p className="style-for-date-timing">
                {job.multiple_date &&
                job.booking_date !== job.end_booking_date ? (
                  <>
                    Booking for{" "}
                    <strong>
                      <Moment format="DD MMM YYYY">{getValidStartDate(job)}</Moment>
                    </strong>
                    <br />
                    to{" "}
                    <strong>
                      <Moment format="DD MMM YYYY">
                        {job.end_booking_date}
                      </Moment>
                    </strong>
                  </>
                ) : (
                  <>
                    Booking for{" "}
                    <strong>
                      <Moment format="DD MMM YYYY">{job.booking_date}</Moment>
                    </strong>
                  </>
                )}
              </p>
              <p className="style-for-date-timing">
                Arrive <strong> {parseTime(job.arrival_time)}</strong> for{" "}
                <strong>{parseTime(job.start_time)}</strong> start, ends{" "}
                <strong>{parseTime(job.end_time)} {" "}</strong>
                <p className='style-for-timezone'><i>
                    Timezone {campus?.timezone}
                    </i>
                </p>
              </p>
              <hr className="search-card-hr mb-4" />
              <table style={{"work-break": "break-all"}}>
                <tbody>
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      <Icon className="map marker alternate" size="large" />
                    </td>
                    <td>
                      <p className="table-column2-margin card-institution-address">
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${inst.institution_name}%2C%20${campus.address_line1}%2C%20${campus.suburb}%20${campus.state}%20${campus.postcode}%2C%20${campus.country}`}
                          target="_blank"
                        >
                          {campus && campus?._id ? campus.address_line1 + ', ' + (campus.address_line2 ? campus.address_line2 + ', ' : '') +
                          campus.suburb + ', ' + campus.state + ', ' + campus.postcode || "" : ""}
                        </a>
                      </p>
                    </td>
                  </tr>
                  <tr className={campus.note_gcal ? "table-row-height" : "d-none"}>
                    <td className="icon-alignment">
                    </td>
                    <td>
                      <p className="table-column2-margin">
                        {campus.note_gcal}
                      </p>
                    </td>
                  </tr>
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      <label className="job-list-label">{user.is_childhood_teacher ? "Room" : "Class"}</label>
                    </td>
                    <td>
                      <p className="table-column2-margin">{level || "-"}</p>
                    </td>
                  </tr>
                  {!user.is_childhood_teacher && (
                    <tr className="table-row-height">
                      <td className="icon-alignment">
                        <label className="job-list-label">Mode</label>
                      </td>
                      <td>
                        <p className="table-column2-margin">
                          {job.online ?
                            job.deliver_from_home === undefined ? "Online"
                              :
                              (job.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
                            :
                            "On Campus"}
                        </p>
                      </td>
                    </tr>
                  )}
                  
                  {/* <tr className="table-row-height">
                    <td className="icon-alignment">
                      <label className="job-list-label">tag</label>
                    </td>
                    <td>
                      <p className="table-column2-margin">{classData.reference_name} </p>
                    </td>
                  </tr> */}
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      {/*<label className="job-list-label">{classData.reference_name}</label>*/}
                      <label className="job-list-label">Days</label>
                    </td>
                    <td>
                      <p className="table-column2-margin">
                        { days?.join(', ') }
                      </p>
                    </td>
                  </tr>
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      <Icon className="clock icon-alignment" size="large" />
                    </td>
                    <td>
                      <p className="table-column2-margin">
                        Total {getTotalHours(job.paid_teaching_hours) || 0} paid
                        teaching hours{user.is_childhood_teacher ? "" : `, ${job.paid_nonteaching_mins} paid non-teaching minutes`}
                        {job.paid_nonteaching_mins
                          ? job.non_teach_calculation === 'daily'
                            ? ' per day'
                            : job.non_teach_calculation === 'weekly'
                              ? ' per week'
                              : job.non_teach_calculation === 'monthly'
                                ? ' per month' : ''
                          : ''}
                      </p>
                    </td>
                  </tr>
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      <Icon className="dollar" size="large" />
                    </td>
                    {inst._id == "62314d2c0ad47e1c334979a3" ? (
                      <td>
                        <p className="table-column2-margin">
                          $80 first hour
                          <br />
                          $55 every subsequent hour in the same week
                        </p>
                      </td>
                    ) : (
                      <td>
                        <p className="table-column2-margin">
                          {
                            inst?.inst_type === 'UNI' ? 
                            (
                              inst?.institution_name === 'Torrens University Language Centre' ? 
                              <>
                                University English Centre $76.78
                              </> :
                              (
                                showRateUni(job)
                              )
                            )
                            : (
                              getQualificationTypeForBooking(qualifications, job.class_level_id) === 'vet'
                                ? <>{showRate(job, inst?._id)}</>
                                : (user?.is_childhood_teacher || (isAdmin && teacher?.is_childhood_teacher))
                                  ? <>{showRateECEC(job)}</>
                                  : <>{ showDefaultRate(job, inst?._id) }</>
                            )
                            
                          }
                        </p>
                        {/* classData.hourly_rate ? (
                          <p className="table-column2-margin">
                            ${classData.hourly_rate} (teaching rate)
                          </p>
                        ) : (
                          <p className="table-column2-margin">
                            $50.85 (teaching rate)
                          </p>
                        )*/}
                      </td>
                    )}
                  </tr>
                  {
                    user.is_childhood_teacher && (
                      <tr className="table-row-height">
                        <td className="icon-alignment">
                          <img src={carParkingImg} alt="SVG" style={{margin: "0 auto", width: "20px", height: "20px"}}/>
                        </td>
                        <td>
                          <p className="table-column2-margin">
                            {campus?.car_parking + " " || ""}
                            {
                              campus?.car_parking_location?.address
                                ? (campus?.car_parking_location?.detail ? campus?.car_parking_location?.detail + " " : "") + campus?.car_parking_location?.address 
                                : ""
                            }
                          </p>
                        </td>
                      </tr>
                    )
                  }
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      <Icon className="user" size="large" />
                    </td>
                    <td>
                      <p className="table-column2-margin">
                        Report to {campus.report_to || "N/A"} on level{" "}
                        {campus.floor_no || "N/A"}
                      </p>
                    </td>
                  </tr>
                  <tr className="table-row-height">
                    <td className="icon-alignment">
                      {/* <Icon className="pencil" size="large" /> */}
                      <DescriptionIcon size="large" />
                    </td>
                    <td>
                      <p className="table-column2-margin">
                        {(!_.isEmpty(classData) ? classData.class_note : job?.class?.class_note) || "No additional notes"}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card-buttons-position" dataid={job?._id}>
              {job.teacher_response === teacherResponse.cancelled ? (
                <p className="card-content font-weight-bold confirm-status-alignment">
                  Cancelled
                </p>
              ) : job.cancelled_by_inst ? (
                <p className="card-content font-weight-bold confirm-status-alignment">
                  Cancelled by Institution
                </p>
              ) : (job.end_booking_date || job.booking_date) < d1 &&
                job.teacher_response === teacherResponse.not_responded ? (
                <p className="card-content font-weight-bold confirm-status-alignment">
                  Expired
                </p>
              ) : job.teacher_response === teacherResponse.not_responded ? (
                isAdmin ? (
                  <p className="card-content font-weight-bold confirm-status-alignment">
                    Unresponded
                  </p>
                ) : (
                  <div className="row">
                    <div className="column-fix card-buttons-flex">
                      <CancelButton
                        className="button_cancel_accept"
                        onClick={() =>
                          submitResponse(
                            user._id,
                            job._id,
                            teacherResponse.rejected,
                            job.multiple_date,
                            job.split_index
                          ).then(() => onRejectJob())
                        }
                      >
                        Reject
                      </CancelButton>
                    </div>
                    <div className="column-fix card-buttons-flex">
                      <ConfirmButton
                        className="button_cancel_accept"
                        onClick={() =>
                          submitResponse(
                            user._id,
                            job._id,
                            teacherResponse.accepted,
                            job.multiple_date,
                            job.split_index
                          ).then(() => onAcceptJob())
                        }
                      >
                        Accept
                      </ConfirmButton>
                    </div>
                  </div>
                )
              ) : job.teacher_response === teacherResponse.accepted ? (
                <p className="card-content font-weight-bold confirm-status-alignment">
                  {(job.end_booking_date || job.booking_date) < d1
                    ? "Completed"
                    : "Confirmed"}
                </p>
              ) : job.teacher_response === teacherResponse.rejected ? (
                <p className="card-content font-weight-bold confirm-status-alignment">
                  Rejected
                </p>
              ) : null}
            </div>
          </div>
          <CancelButton
            id="request-day-off-button"
            className={requestDayOff ? "mt-3" : "d-none"}
            onClick={() => setShowRequestDayOffPopup(true)}
          >
            Request Day Off
          </CancelButton>
        </div>
        {!job.cancelled_by_inst &&
          job.teacher_response == teacherResponse.accepted &&
          (job.end_booking_date || job.booking_date) >= d1 && (
            <>
              <Icon
                name="ban"
                className={requestDayOff ? "d-none" : "block-icon"}
                size="large"
                data-tip
                data-for="tooltipban"
                onClick={() => setShowCancelPopup(true)}
              />
              <ReactTooltip
                place="bottom"
                backgroundColor="rgb(47, 224, 222)"
                id="tooltipban"
                effect="solid"
              >
                Cancel
              </ReactTooltip>
            </>
          )}

        <CancelBookingPopup
          show={showCancelPopup}
          booking={job}
          inst={inst}
          campus={campus}
          level={level}
          onClose={() => setShowCancelPopup(false)}
          onConfirm={(teacher_cancel_reason) => {
            // console.log(teacher_cancel_reason)
            submitResponse(
              user._id,
              job._id,
              teacherResponse.cancelled,
              job.multiple_date,
              job.split_index,
              teacher_cancel_reason
            ).then(() => onCancelJob());
          }}
        />

        <RequestDayOffPopup
          show={showRequestDayOffPopup}
          booking={job}
          inst={inst}
          campus={campus}
          level={level}
          onClose={() => setShowRequestDayOffPopup(false)}
          onConfirm={() => {
            handleRequestDayOff(job);
            setShowRequestDayOffPopup(false)
          }}
        />

        <ForumIcon
          className={requestDayOff ? "d-none" : "chat-icon"}
          fontSize="default"
          data-tip
          data-for="tooltipchat"
        />
        <ReactTooltip
          place="bottom"
          backgroundColor="rgb(47, 224, 222)"
          id="tooltipchat"
          effect="solid"
          visibility="hidden"
          text-align="center"
          color="#fff"
          margin-top="-10px"
          z-index="10"
          font-size="14px"
          border-radius="2px"
          line-height="15px"
          transition="all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)"
          margin-left="-15px"
        >
          Chat unavailable
        </ReactTooltip>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

export default connect(mapStateToProps)(BookingCard);
